module.exports = __webpack_public_path__ + "img/engage-fig-3.be4ffd87.png";